import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { Field, FieldRow, Fieldset, Label } from '@/common/components/fieldset';
import { Heading } from '@/common/components/heading';
import { Input } from '@/common/components/input';
import { Text } from '@/common/components/text';

export const Route = createFileRoute(
  '/applications/$application-id/identity-check/verify-code'
)({
  component: VerifyCodeComponent
});

function VerifyCodeComponent() {
  return (
    <div className="p-8">
      <Heading>One-Time Password Authentication</Heading>

      <Text>Please allow up to five minutes to receive code to mobile phone. Then enter code and proceed.</Text>

      <Fieldset>
        <FieldRow cols={4}>
          <Field>
            <Label>Code</Label>
            <Input name="code" maxLength={6} />
          </Field>
        </FieldRow>
      </Fieldset>

      <ButtonGroup>
        <Button to="/applications/$application-id/identity-check/security-questions" params={{ 'application-id': '1' }} outline>Didn't Receive Code</Button>
        <Button to="/applications/$application-id/identity-check/security-questions" params={{ 'application-id': '1' }}>Next</Button>
      </ButtonGroup>
    </div>
  );
}
